import { DeskLegsToSimpleSapElementMapper } from '../desk/deskLegsToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import store from '@/store';

export class CtLegsToSimpleSapElementMapper extends DeskLegsToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const width = Number(this.body.model.split('_')[2].split('.')[0]);
        const code = this.toLegsType(element);
        const dim1 = 6;
        const dim2 = width === 550 ? 1 : 2;
        const type = this.formatType(code, dim1, dim2);
        return [SimpleSapElement.LEG(type, '')];
    }
}